import { render, staticRenderFns } from "./CategorySwiper.vue?vue&type=template&id=6bf2e48e"
import script from "./CategorySwiper.vue?vue&type=script&lang=js"
export * from "./CategorySwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports